export const data = (name: string) => {
	const dataEl = document.getElementById("vxgooglev1_data");
	if (!dataEl) {
		throw new Error("data element not found");
	}
	return {
		asString: () => dataEl.dataset[name] || "",
		asObject: () => JSON.parse(dataEl.dataset[name] || "{}"),
		asInt: () => parseInt(dataEl.dataset[name] || "0"),
		asBool: () => (dataEl.dataset[name] === '1')
	};
}
